import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import UsersInfoTable from './UsersInfoTable';
import UserInfo from './UserInfo';
import { getAllUsersAsDirector } from 'db/functions';

const useStyles = makeStyles(() => ({}));

const UsersInfo = ({ authUser }) => {
  const classes = useStyles();
  const [view, setView] = useState('UsersInfoTable');
  const [selectedUserID, setSelectedUserID] = useState(undefined);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const asyncFunction = async () => {
      const users = await getAllUsersAsDirector();
      setUsers(users);
    };
    asyncFunction();
  }, []);

  const goToUserView = userID => {
    setSelectedUserID(userID);
    setView('UserInfo');
  };

  const goToUsersInfoTable = () => {
    setSelectedUserID(undefined);
    setView('UsersInfoTable');
  };

  if (view === 'UsersInfoTable') return <UsersInfoTable users={users} goToUserView={goToUserView} authUser={authUser} />;
  if (view === 'UserInfo')
    return <UserInfo users={users} goToUsersInfoTable={goToUsersInfoTable} selectedUserID={selectedUserID} authUser={authUser} />;
};

export default UsersInfo;
